import { Controller } from 'react-hook-form';
import { FC } from 'react';

import { EnumRadioGroup } from '../../heating/components/enumRadioGroup';
import { JaNeiVetIkke } from '../../../../../utils/registerEnums';
import { EnumRadioButton } from '../../heating/components/enumRadioButton';
import { AboutFormControlProps } from '../../types';

export const GjenvinningAvVarmeRadioGroup: FC<AboutFormControlProps> = ({ control }) => {
  return (
    <Controller
      name="ventilasjon.gjenvinningAvVarme"
      control={control}
      render={({ field, fieldState }) => (
        <EnumRadioGroup
          error={fieldState.error}
          value={field.value}
          labelKey="register.ventilation.gjenvinningAvVarme.label"
          helperTextKey="register.ventilation.gjenvinningAvVarme.information"
          onChange={(val) => field.onChange(val as JaNeiVetIkke)}
        >
          <EnumRadioButton i18nPrefix="register" value={JaNeiVetIkke.Ja} />
          <EnumRadioButton i18nPrefix="register" value={JaNeiVetIkke.Nei} />
          <EnumRadioButton i18nPrefix="register" value={JaNeiVetIkke.VetIkke} />
        </EnumRadioGroup>
      )}
    />
  );
};
